import { render, staticRenderFns } from "./RatingModal.vue?vue&type=template&id=bd590d36&scoped=true&"
import script from "./RatingModal.vue?vue&type=script&lang=js&"
export * from "./RatingModal.vue?vue&type=script&lang=js&"
import style0 from "./RatingModal.vue?vue&type=style&index=0&id=bd590d36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd590d36",
  null
  
)

export default component.exports